import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const UpsellPaywallSwitchers = lazyWithPreload(
  () => import('./UpsellPaywallSwitchers'),
)
